import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
import DetailedDropdownItem from 'flarum/common/components/DetailedDropdownItem';
import SplitDropdown from 'flarum/common/components/SplitDropdown';
export default class SubscriptionMenu extends Dropdown {
  constructor() {
    super(...arguments);
    _defineProperty(this, "options", [{
      subscription: null,
      icon: 'far fa-star',
      label: app.translator.trans('flarum-subscriptions.forum.sub_controls.not_following_button'),
      description: app.translator.trans('flarum-subscriptions.forum.sub_controls.not_following_text')
    }, {
      subscription: 'follow',
      icon: 'fas fa-star',
      label: app.translator.trans('flarum-subscriptions.forum.sub_controls.following_button'),
      description: app.translator.trans('flarum-subscriptions.forum.sub_controls.following_text')
    }, {
      subscription: 'ignore',
      icon: 'far fa-eye-slash',
      label: app.translator.trans('flarum-subscriptions.forum.sub_controls.ignoring_button'),
      description: app.translator.trans('flarum-subscriptions.forum.sub_controls.ignoring_text')
    }]);
    _defineProperty(this, "possibleButtonAttrs", {
      null: {
        icon: 'far fa-star',
        label: app.translator.trans('flarum-subscriptions.forum.sub_controls.follow_button')
      },
      follow: {
        icon: 'fas fa-star',
        label: app.translator.trans('flarum-subscriptions.forum.sub_controls.following_button')
      },
      ignore: {
        icon: 'far fa-eye-slash',
        label: app.translator.trans('flarum-subscriptions.forum.sub_controls.ignoring_button')
      }
    });
  }
  view() {
    var _this$possibleButtonA;
    const discussion = this.attrs.discussion;
    const subscription = discussion.subscription();
    const buttonAttrs = (_this$possibleButtonA = this.possibleButtonAttrs[subscription != null ? subscription : 'null']) != null ? _this$possibleButtonA : this.possibleButtonAttrs.null;
    const preferences = app.session.user.preferences();
    const notifyEmail = preferences['notify_newPost_email'];
    const notifyAlert = preferences['notify_newPost_alert'];
    const tooltipText = extractText(app.translator.trans(notifyEmail ? 'flarum-subscriptions.forum.sub_controls.notify_email_tooltip' : 'flarum-subscriptions.forum.sub_controls.notify_alert_tooltip'));
    const shouldShowTooltip = (notifyEmail || notifyAlert) && subscription === null;
    return m(SplitDropdown, {
      className: "SubscriptionMenu",
      buttonClassName: "SubscriptionMenu-button--".concat(subscription),
      tooltip: shouldShowTooltip ? tooltipText : null,
      mainAction: m(Button, {
        className: 'SubscriptionMenu-button',
        icon: buttonAttrs.icon,
        onclick: this.saveSubscription.bind(this, discussion, ['follow', 'ignore'].indexOf(subscription) !== -1 ? null : 'follow')
      }, buttonAttrs.label)
    }, this.options.map(attrs => m(DetailedDropdownItem, Object.assign({}, attrs, {
      onclick: this.saveSubscription.bind(this, discussion, attrs.subscription),
      active: subscription === attrs.subscription
    }))));
  }
  saveSubscription(discussion, subscription) {
    discussion.save({
      subscription
    });

    // @ts-ignore
    this.$('.SubscriptionMenu-button').tooltip('hide');
  }
}
flarum.reg.add('flarum-subscriptions', 'forum/components/SubscriptionMenu', SubscriptionMenu);